module.exports = __webpack_public_path__ + "img/48.f8121c1f.png";